export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-50/70">
      <div className="mx-auto px-4 md:px-6 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-heading font-black text-background-50">
              黑料在线
            </span>
            <p className="text-sm text-background-50/50 mt-3 leading-relaxed">
              国内领先的系列化黑料整理与观看平台。专注收集暴走黑料、黑料社等特色黑料系列，提供暴走黑料在线观看与黑料社在线观看一站式吃瓜体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '精彩视频', href: '#media' },
                { label: '最新快讯', href: '#updates' },
                { label: '热门专题', href: '#cards' },
                { label: '热门排行', href: '#ranking' },
                { label: '专题合集', href: '#index' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              热门系列
            </h4>
            <ul className="space-y-2.5">
              {[
                '暴走黑料系列',
                '黑料社系列',
                '圈内人爆料',
                '综艺黑幕特辑',
                '网红翻车实录',
              ].map((s) => (
                <li key={s}>
                  <span className="text-sm text-background-50/50 cursor-pointer hover:text-primary-400 transition-colors">
                    {s}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 黑料在线. 本站内容仅供娱乐参考，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}